// RUT formatting/normalization helpers (CL).
// Pure functions extracted from DocumentsCreate.vue to make them testable and
// reusable (e.g. by the PE document form). The `country` param preserves the
// original guard (non-CL values do not get Chilean RUT formatting).

// Strip dots and dash: "12.345.678-9" -> "123456789"
export function unformatRut (rut) {
  if (!rut) return ''
  return rut.replace(/\./g, '').replace(/-/g, '')
}

// Strip only dots, keep the dash: "12.345.678-9" -> "12345678-9"
export function cleanRut (rut) {
  if (!rut) return ''
  return rut.replace(/\./g, '')
}

// Normalize to "<number>-<dv>" (no dots, uppercase check digit)
export function normalizeRutFormat (rut) {
  if (!rut) return ''
  let cleaned = rut.replace(/[^0-9Kk-]/g, '')

  if (cleaned.includes('-')) {
    const parts = cleaned.split('-')
    if (parts.length === 2) {
      const number = parts[0].replace(/[^0-9]/g, '')
      let dvPart = parts[1].replace(/[^0-9Kk]/g, '').toUpperCase()
      if (dvPart.length > 1) {
        const extraNumbers = dvPart.slice(0, -1).replace(/[^0-9]/g, '')
        const dv = dvPart.slice(-1)
        if (extraNumbers) {
          return `${number}${extraNumbers}-${dv}`
        }
        return `${number}-${dv}`
      }
      return `${number}-${dvPart}`
    }
  }

  const lastChar = cleaned.slice(-1)
  if (/[0-9Kk]/.test(lastChar) && cleaned.length > 1) {
    const number = cleaned.slice(0, -1).replace(/[^0-9]/g, '')
    const dv = lastChar.toUpperCase()
    return `${number}-${dv}`
  }

  return cleaned.replace(/[^0-9]/g, '')
}

// Backend format: no dots, with a dash before the check digit
export function unformatRutForBackend (rut, country = 'CL') {
  if (!rut) return ''
  let cleaned = rut.replace(/\./g, '')
  if (country !== 'CL') return cleaned
  if (!cleaned.includes('-')) {
    const lastChar = cleaned.slice(-1)
    if (/[0-9Kk]/.test(lastChar)) {
      const numbers = cleaned.slice(0, -1)
      cleaned = `${numbers}-${lastChar.toUpperCase()}`
    }
  }
  return cleaned
}

// Display format: "12.345.678-9" (with dots, uppercase check digit)
export function formatRut (value, country = 'CL') {
  if (!value) return ''
  if (country !== 'CL') return value
  let rut = value.replace(/[^0-9kK-]/g, '')
  rut = rut.replace(/-/g, '')
  if (rut.length > 1) {
    const dv = rut.slice(-1)
    let body = rut.slice(0, -1)
    body = body.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    rut = `${body}-${dv}`
  }
  return rut.toUpperCase()
}
